export class O2AwardsReportFilterCriteria {
    fromYear: number;
    toYear: number;
    regions: string[];

    constructor(fromYear, toYear, regions) {
        this.fromYear = fromYear;
        this.toYear = toYear;
        this.regions = regions;
    }
}